import { AcessAction, AcessItem } from 'types/enum/items';
import defineAbility from './defineAbility';
import { subject } from '@casl/ability';
import { UsuarioF } from 'types';

export const checkCan = (user: UsuarioF, action: AcessAction, on: AcessItem, item?: any) => {
    return defineAbility(user).can(action, item ? subject(on, item) : on);
};
